import React from "react";
import { SideNav, BottomNav, MobileMenuProvider } from "./Navigation";
import TermsReprompt from "./TermsReprompt";

export default function Layout({ children }) {
    return (
        <MobileMenuProvider>
            <div className="min-h-screen bg-alpine-mist">
                <SideNav />
                <main className="lg:ml-64 pb-[calc(5rem+env(safe-area-inset-bottom))] lg:pb-0 min-h-screen">{children}</main>
                <BottomNav />
                <TermsReprompt />
            </div>
        </MobileMenuProvider>
    );
}
